var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCwCuracao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H-7.68V45.12H60V0Z",
    fill: "#002B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 28.2H-7.68V33.84H60V28.2Z",
    fill: "#F9E814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.479 3.76025L51.727 6.39246H48.7187L51.3509 7.52055L50.5989 10.1528L52.479 9.02467L54.7352 10.5288L53.9831 7.89658L55.8633 6.39246H53.2311L52.479 3.76025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9568 10.0286L43.954 13.5386H39.9425L43.4526 15.0429L42.4497 18.5529L44.9568 17.0486L47.9654 19.0543L46.9626 15.5443L49.4697 13.5386H45.9597L44.9568 10.0286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwCuracao);
export default __webpack_public_path__ + "static/media/cw Curacao.9c3a6b79b240d8a0b9afbc340d8caa6c.svg";
export { ForwardRef as ReactComponent };